export enum KpiEAITypes {
  'LOAD_REQUEST' = '@kpiEAI/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@kpiEAI/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@kpiEAI/LOAD_FAILURE',
}

export interface IPoint {
  time: string;
  value: number;
}

export interface IKpi {
  card: string;
  data: IPoint[];
  protocolos: number[];
  qtd: number;
  total: number;
  percentual: number;
}

export interface KpiEAIState {
  readonly data: IKpi[];
  readonly error: boolean;
  readonly loading: boolean;
}
